/**
 * Single source of truth for user-facing document labels on the frontend.
 * `doc_type` is the internal key (never renamed). `doc_label` is what we show.
 * If a document was uploaded before the label change, fall back here.
 */
const DOC_LABELS = {
    photo: 'Profile Photo',
    passport: 'Passport',
    interpol: 'Interpol/Police Clearance',
    video_intro: 'Video Introduction',
    medical_report: 'Medical Report',
    additional: 'Additional Document',
    visa: 'Visa Document',
    flight_ticket: 'Flight Ticket',
    offer_letter: 'Offer Letter',
};

export function getDocLabel(doc) {
    if (!doc) return '';
    // For 'additional' documents, the user sets a custom label — always prefer it.
    if (doc.doc_type === 'additional' && doc.doc_label) return doc.doc_label;
    // Otherwise prefer the canonical map so a stale doc_label in the DB doesn't show.
    return DOC_LABELS[doc.doc_type] || doc.doc_label || (doc.doc_type || '').replace('_', ' ');
}
